// @ts-nocheck
import { productAddToListLinkStyles } from "@insite/content-library/Components/ProductAddToListLink";
import PlusCircle from "@insite/mobius/Icons/PlusCircle";
import getColor from "@insite/mobius/utilities/getColor";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import { css } from "styled-components";

Object.assign(productAddToListLinkStyles, {
    link: {
        icon: {
            iconProps: {
                src: PlusCircle,
                size: "20",
                color: `${getColor("secondary")}`,
                css: css`
                    margin-right: ${pxToRem(5)};
                `,
            },
        },
    },
});
